import React from 'react'
import { MessagingView } from '../code/enums/Enums'
import '../css/messagingtabcontrol.css'

interface IMessagingTabControlParams {
    selectedView: MessagingView;
    selectedViewChange: Function;
}

export default function MessagingTabControl({ selectedView, selectedViewChange }: IMessagingTabControlParams) {
    
    function handleTabClick(view: MessagingView) {
        selectedViewChange(view);
    }

    function buildAhref(view: MessagingView, label: string) {
        return (
            <React.Fragment>
                {view === selectedView ?
                    <button className="nav-link active" type="button" role="tab" aria-selected="true"
                        onClick={() => { handleTabClick(view); }}
                    >{label}</button>
                    :
                    <button className="nav-link" type="button" role="tab" aria-selected="false"
                        onClick={() => { handleTabClick(view); }}
                    >{label}</button>
                }
            </React.Fragment>
        );
    }

    return (
        <ul className="customerinfotabs nav nav-tabs">
            <li className="nav-item">
                {buildAhref(MessagingView.Log, "View Logs")}
            </li>
            <li className="nav-item">
                {buildAhref(MessagingView.Add, "Add Log")}
            </li>
            <li className="nav-item">
                {buildAhref(MessagingView.Email, "Send Email")}
            </li>
        </ul>
    )
}
